var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayfulMessageIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.354,
    height: 7.354,
    viewBox: "0 0 7.354 7.354",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "basketball",
    transform: "translate(-12 -12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83762",
    "data-name": "Path 83762",
    d: "M15.677,12a3.677,3.677,0,1,0,3.677,3.677A3.677,3.677,0,0,0,15.677,12Zm3.139,3.414H17.263a3.784,3.784,0,0,1,.719-1.879,3.136,3.136,0,0,1,.833,1.879Zm-2.876,0V12.538a3.13,3.13,0,0,1,1.651.64,4.272,4.272,0,0,0-.853,2.236Zm-.525,0h-.8a4.272,4.272,0,0,0-.853-2.236,3.13,3.13,0,0,1,1.651-.64Zm0,.525v2.876a3.13,3.13,0,0,1-1.651-.64,4.272,4.272,0,0,0,.853-2.236Zm.525,0h.8a4.272,4.272,0,0,0,.853,2.236,3.13,3.13,0,0,1-1.651.64Zm-2.569-2.4a3.784,3.784,0,0,1,.72,1.879H12.539a3.136,3.136,0,0,1,.833-1.879Zm-.833,2.4h1.552a3.784,3.784,0,0,1-.719,1.879A3.136,3.136,0,0,1,12.538,15.94Zm5.444,1.879a3.784,3.784,0,0,1-.72-1.879h1.552a3.136,3.136,0,0,1-.833,1.879Z",
    fill: "#ffad4d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayfulMessageIcon);
export default __webpack_public_path__ + "static/media/playful-message-icon.e5449de7a5b6b6eaaf1c516078822342.svg";
export { ForwardRef as ReactComponent };